<template>
  <div :class="['card',{seletcard:card===current}]">
    <div class="typeTitle">{{ card.ClassName }}</div>
    <div class="showline">
      <div class="leftName">
        <img v-if="card.Icon" :src="card.Icon" />
        <span v-if="!card.Icon" class="aviter"
          >{{ xy.showName(card.TeacherName) }}
        </span>
        <span class="name">{{ card.TeacherName }}</span>
      </div>
      <div class="score">{{ card.Score }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    card: {
      type: Object,
      default() {
        return {
          message: '语文课程',
          name: '曹合飞',
          url: 'https://timgsa.baidu.com/timg?image',
          score: '9.5'
        }
      }
    },
    current: {
      type: Object,
      default() {
        return {
          message: '语文课程',
          name: '曹合飞',
          url: 'https://timgsa.baidu.com/timg?image',
          score: '9.5'
        }
      }
    },
  },
  created() {
    console.log(this.card)
  },
  mounted() {},
  methods: {}
}
</script>
<style lang='less' scoped>
.card {
  width: 295px;
  height: 93px;
  padding-left: 15px;
  box-sizing: border-box;
  background: white;
  border-radius: 4px;
  margin: 0 auto;
  border: 1px white solid;
}
.seletcard{
  border: 1px #1677FF solid;

}
.typeTitle {
  margin-top: 10px;
  line-height: 22px;
  // prettier-ignore
  font-size: 16Px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
.showline {
  height: 60px;
  line-height: 60px;
}
.leftName {
  float: left;
  img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    vertical-align: top;
    margin-top: 13px;
  }
  .aviter {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    vertical-align: top;
    margin-top: 13px;
    background: #4196ff;
    line-height: 30px;
    // prettier-ignore
    font-size: 14Px;
    color: white;
    text-align: center;
  }
  .name {
    // prettier-ignore
    font-size: 14Px;
    font-weight: 400;
    margin-left: 10px;
    color: rgba(26, 26, 26, 0.85);
    vertical-align: top;
  }
}
.score {
  float: right;
  margin-right: 20px;
  // prettier-ignore
  font-size: 28Px;
  color: #e28d30;
}
</style>
